export default __webpack_public_path__ + "navigation-examples-advanced-960-6e926567984568d26e2d3f4531ec2701.png";